import { ReactNode, ReactElement } from "react";
import { AlertOctagon, AlertTriangle } from "react-feather";
import ReactMarkdown from "react-markdown";
import take from "lodash/take";

function ErrorIcon() {
  return (
    <div aria-hidden="true" className="errorIcon">
      <AlertOctagon size={20} />
    </div>
  );
}

function WarningIcon() {
  return (
    <div aria-hidden="true" className="errorIcon">
      <AlertTriangle size={20} />
    </div>
  );
}

export function FieldError({
  id,
  messages,
  className = "errors",
}: {
  id: string;
  messages: ReactNode[];
  className?: "errors" | "warnings";
}): ReactElement | null {
  if (messages.length === 0) {
    return null;
  }
  const Icon = className === "errors" ? ErrorIcon : WarningIcon;
  return (
    <div id={id} className={className}>
      <Icon />
      {take(messages, 1).map((message, index) => (
        /* There's nothing else we can use here really, and
           error messages should never change order */
        /* eslint-disable-next-line react/no-array-index-key */
        <div className="error" key={index}>
          {typeof message === "string" ? (
            <ReactMarkdown>{message}</ReactMarkdown>
          ) : (
            message
          )}
        </div>
      ))}
    </div>
  );
}
